// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__8w48Y"};